export const ClaimStatementStepTwoRadioButtons = {
  payment_not_recieved: {
    value: "payment_not_recieved",
    text: "платеж не поступил в Банк/Компанию"
  },

  payment_delayed: {
    value: "payment_delayed",
    text: "несвоевременно поступил в Банк/Компанию"
  },

  credit_payment_delayed: {
    value: "credit_payment_delayed",
    text: "очередной платеж по кредитному и/или иному договору не был оплачен своевременно"
  },

  credit_debt_payment_delayed: {
    value: "credit_debt_payment_delayed",
    text: "задолженность по кредитному и иному договору не была погашена вовремя"
  },

  payment_reason_other: {
    value: "payment_reason_other",
    text: "другие"
  },

  debt_fine_not_applied: {
    value: "debt_fine_not_applied",
    text: "наложены не были"
  },

  debt_fine_applied: {
    value: "debt_fine_applied",
    text: "были применены"
  },
}

export const StatementComponentNames = {
  refund_of_funds: {
    refund_index: "refund-index",
    refund_one: "refund-1",
    refund_two: "refund-2",
    refund_three: "refund-3",
    refund_four: "refund-4",
  },

  free_form: {
    free_form_index: "free_form-index",
    free_form_one: "free_form-1",
    free_form_two: "free_form-2",
    free_form_three: "free_form-3",
  },

  technical_failure: {
    technical_failure_index: "technical_failure-index",
    technical_failure_one: "technical_failure-1",
    technical_failure_two: "technical_failure-2",
    technical_failure_three: "technical_failure-3",
  },

  claim: {
    claim_index: "claim-index",
    claim_one: "claim-1",
    claim_two: "claim-2",
    claim_three: "claim-3",
  },
}

export const ErrorMessages = {
  service_unavailable: {
    title: "<p>Что-то пошло не так!</p>",
    text: "<p>Попробуйте обновить страницу, если ничего не выходит, то попробуйте позже.</p>"
  }
}